export const CV_PREFIX = 'calendar-view';
export const CV_FULL_DAY_HEIGHT = 116;
export const CV_TIME_LINE_HEIGHT = 18;
